export default __webpack_public_path__ + "static/media/leftArrow.d6d7d5c0.svg";